import {
  FOC_TOUR_LABEL_RES_211,
  focFeedbackPopoverHtml,
} from '../focTourFeedback';
import { FOC_RES_211_TOUR_HREF as HREF } from '../focTourHrefs';
import {
  FOC_REQUIRED_DISPOSITION,
  IOC_CARRYOVER_DISPOSITION,
  focResTourPopoverHtml,
  requirement,
  type FocResTourStepDef,
} from './focResTourTypes';

export const FOC_RES_211_TOUR_PARAM = 'focRes211Tour';
export const FOC_RES_211_TOUR_HREF = HREF;
export { focResTourPopoverHtml };

/** Resume param after hub bootstrap navigates into IAP resources. */
export const FOC_RES_211_TOUR_IAP_PARAM = 'focRes211Tour';

export function focRes211TourIapHref(incidentId: string): string {
  return `/iap/${incidentId}/resources?${FOC_RES_211_TOUR_IAP_PARAM}=1`;
}

export const FOC_RES_211_TOUR_STEPS: FocResTourStepDef[] = [
  {
    id: 'sectionIntro',
    surface: 'ics211',
    tour: 'resources-ics211',
    title: FOC_TOUR_LABEL_RES_211,
    description:
      'Check-in, check-out, and ICS 211/211A support personnel and resource accountability, daily sign-in/out, and custody tracking for the incident.',
  },
  requirement({
    id: 'ir014',
    requirementId: 'US-IR014',
    name: 'Set Check-In Status',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'ics211',
    tour: 'resources-check-in-status',
    description:
      'Set check-in status (Checked-In, Checked-Out) when adding a member so initial availability is recorded.',
  }),
  requirement({
    id: 'ir020',
    requirementId: 'US-IR020',
    name: 'Update Activation, Check-In, and Sign-In Status',
    disposition: IOC_CARRYOVER_DISPOSITION,
    surface: 'ics211',
    tour: 'resources-check-in-status',
    description:
      'Update a member’s activation, check-in, and sign-in statuses when editing so state stays accurate.',
  }),
  requirement({
    id: 'res004',
    requirementId: 'FOC-RES-004',
    name: 'Standard ICS Check-In Workflow',
    disposition: FOC_REQUIRED_DISPOSITION,
    surface: 'ics211',
    tour: 'resources-ics211',
    description:
      'PRATUS supports standard ICS 211 and 211A concepts for check-in, check-out, daily sign-in/out, personnel accountability, resource accountability, and incident documentation.',
    bullets: [
      'FOC-RES-004a — Roster and Finance linkage for status, activity logs, CG-5136-compatible time/cost, and demobilization.',
      'FOC-RES-004b — Field check-in options including mobile and QR-enabled workflows where authorized.',
      'FOC-RES-004c — Resource custody recorded when equipment, supplies, and accountable resources check in or out.',
    ],
  }),
  {
    id: 'focFeedback',
    title: 'FOC Feedback Notes',
    description: focFeedbackPopoverHtml(FOC_TOUR_LABEL_RES_211),
  },
];

export function focRes211TourNavVisible(enabled: boolean): boolean {
  return enabled;
}

export function focRes211TourStepIds(): string[] {
  return FOC_RES_211_TOUR_STEPS.map((step) => step.id);
}
